import {chain} from 'lodash';
import memoize from 'lru-memoize';
import React, {FC} from 'react';
import styled from 'styled-components';

import {Icon} from '../../../../../../libs/shared/ui/src/components/icon/icon';
import {UserTheme, useUserTheme} from '../../../../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Props.
 */

interface CellRatingProps {
  rating: string;
  isSelected?: boolean;
}

/*
 * Style.
 */

const StyledRatingDiv = styled.div`
  flex-grow: 1;
  flex-shrink: 0;

  display: grid;
  grid-auto-flow: column;
  grid-column-gap: 4px;
  grid-auto-columns: max-content;
  padding: 2px 0;
`;

/*
 * Component.
 */

export const CellRating: FC<CellRatingProps> = ({rating, isSelected}) => {
  const starCount = countStars(rating);
  const theme = useUserTheme();
  return (
    <StyledRatingDiv>
      <Icon name="starTiny" color={getStarColor(isSelected, starCount, 0, theme)} />
      <Icon name="starTiny" color={getStarColor(isSelected, starCount, 1, theme)} />
      <Icon name="starTiny" color={getStarColor(isSelected, starCount, 2, theme)} />
      <Icon name="starTiny" color={getStarColor(isSelected, starCount, 3, theme)} />
      <Icon name="starTiny" color={getStarColor(isSelected, starCount, 4, theme)} />
    </StyledRatingDiv>
  );
};

/*
 * Helpers.
 */

const countStars = memoize(10)((src: string) =>
  chain(src)
    .filter((c) => c === '\u2605')
    .size()
    .value(),
);

function getStarColor(isSelected: boolean | undefined, starCount: number, index: number, theme: UserTheme) {
  const isStarFilled = index < starCount;
  if (isSelected && isStarFilled) {
    return theme.greys.white;
  }

  if (isSelected) {
    return theme.alphas.white40;
  }

  if (isStarFilled) {
    return theme.palette.yellow.shade40;
  }

  return theme.greys.shade40;
}
